<div class="preview">
    @if (!showEmulatorDialog) {
        <div class="preview-header">
            <div class="preview-title">Flow preview settings</div>
            <div class="preview-desc">Configure and test your flows.</div>
        </div>
        <div class="preview-settings-block">
            <div class="form-group">
                <label class="preview-label" for="channel">Select Channel</label>
                <mat-select
                        (selectionChange)="resetEmulator()"
                        #approvalsList
                        class="clickatellInput preview-select"
                        [ngClass]="'channel' + selectedChannel"
                        panelClass="preview-channel-selection-panel"
                        [(value)]="selectedChannel"
                        [(ngModel)]="selectedChannel"
                        id="channel"
                        disableOptionCentering
                        hideSingleSelectionIndicator
                >
                    <mat-select-trigger>
                        <div class="channel-option-content">
                            <div>
                                <img
                                        class="channel-img"
                                        src="../../../assets/img/channel/{{ selectedChannel }}.svg"
                                />
                            </div>
                            <div>
                                <span class="channel-name-text">{{ selectedChannel | channelName }}</span>
                            </div>
                        </div>
                    </mat-select-trigger>
                    @for (channel of channels; track channel) {
                        <mat-option
                                [value]="channel.config['channel-id']"
                                class="channelOptions"
                        >
                            <div class="channel-option-content">
                                <img
                                        class="channel-img"
                                        src="../../../assets/img/channel/{{ channel.config['channel-id'] }}.svg"
                                />
                                {{ channel.config['channel-id'] | channelName }}
                            </div>

                        </mat-option>
                    }
                </mat-select>
            </div>
            <form id="dialer-form" [formGroup]="emulatorFormGroup">
                <!-- reads the element of the selected channel !! Part of a Form Group !!-->
                @for (element of emulatorConfig[selectedChannel]; track element) {
                    <div class="dialer-form">
                        <!-- if element type is input -->
                        @if (element.type === 'input') {
                            <div class="form-group" [ngClass]="{'hide-additional': !(element | checkShowAdditional: showAdditionalSettings)}">
                                <ng-component
                                        *ngTemplateOutlet="previewInputLabel; context: { element: element }"></ng-component>
                                <!-- create the input field  -->
                                <input
                                        type="text"
                                        class="clickatellInput"
                                        id="{{ element.formControlName }}"
                                        [placeholder]="element.formControlName === 'sourceId' && isBsuid.value ? 'Enter a BSUID' : element.placeholder"
                                        formControlName="{{ element.formControlName }}"
                                />
                            </div>
                        }
                        <!-- if element type is optgroup !! ATM only Network Options !! -->
                        @if (element.type === 'optgroup') {
                            <div class="form-group">
                                <!-- set the lable for Option Group -->
                                <ng-component
                                        *ngTemplateOutlet="previewInputLabel; context: { element: element }"></ng-component>
                                <mat-select
                                        class="clickatellInput preview-select"
                                        panelClass="selectPanel"
                                        id="{{ element.formControlName }}"
                                        formControlName="{{ element.formControlName }}"
                                        [(ngModel)]="selectedMobileNetwork"
                                >
                                    @for (parentKey of getObjectKeys(element.group); track parentKey) {
                                        <mat-optgroup
                                                label="{{ parentKey }}"
                                        >
                                            @for (child of element.group[parentKey]; track child) {
                                                <mat-option [value]="child.id">
                                                    {{ child.vendor }}
                                                </mat-option>
                                            }
                                        </mat-optgroup>
                                    }
                                </mat-select>
                            </div>
                        }
                        @if (element.type === 'datalist') {
                            <div class="form-group autocomplete-block">
                                <ng-component
                                        *ngTemplateOutlet="previewInputLabel; context: { element: element }"></ng-component>
                                <input
                                        class="clickatellInput dataList"
                                        type="text"
                                        placeholder="{{ element.placeholder }}"
                                        matInput
                                        formControlName="{{ element.formControlName }}"
                                        [matAutocomplete]="auto"
                                        #routeInput
                                />
                                <div class="mat-select-arrow-wrapper" #selectArrow>
                                    <div class="mat-select-arrow"></div>
                                </div>
                                <mat-autocomplete #auto="matAutocomplete" (closed)="onPanelClosed()"
                                                  (opened)="onPanelOpen()" (optionSelected)="changeRoute($event)">
                                    @if (filteredRoutesList[selectedChannel]; as fRoutes) {
                                        @if (fRoutes.length > 0) {
                                            @for (route of fRoutes; track route) {
                                                <mat-option
                                                        class="data-select-option"
                                                        [value]="route.name"
                                                        [ngStyle]="{ 'line-height': 1 }">
                                                    {{ route.name }}
                                                    <span class="data-select-option-channel-path">{{
                                                            route.flowName | getFlowPath
                                                        }}</span>
                                                </mat-option>
                                            }
                                        } @else {
                                            <mat-option disabled class="data-select-option-nonfound"
                                                        [ngStyle]="{ 'line-height': 1 }">
                                                No results found.
                                            </mat-option>
                                        }
                                    }
                                </mat-autocomplete>
                            </div>
                        }
                    </div>
                }
                <ng-template #previewInputLabel let-element="element">
                    <label class="preview-label" for="{{ element.formControlName }}">
                        {{ element.formControlName === 'sourceId' && isBsuid.value ? 'BSUID' : element.lable }}
                        @if (element.tooltip) {
                            <span class="label-tooltip">
                        <app-cms [cmsData]="element.lable | buildCMSConditions: selectedChannel"></app-cms>
                      </span>
                        }
                        @if (element.optional) {
                            <span class="optional">Optional</span>
                        }
                    </label>
                </ng-template>
                @if (selectedChannel === 7) {
                    <button
                            class="view-additional-settings-btn"
                            [ngClass]="{'hide-settings': showAdditionalSettings}"
                            (click)="toggleShowAdditionalSettings()"
                    >
                        {{ showAdditionalSettings ? 'Hide' : 'View' }} Additional Settings
                    </button>
                }
                @if (selectedChannel === 8 && (emulatorChannelConfig | async)?.config['require-contact-book-lookup']) {
                    <div class="form-group">
                        <mat-checkbox [formControl]="isBsuid">Simulate BSUID</mat-checkbox>
                    </div>
                    <div class="form-group">
                        <mat-checkbox [formControl]="triggerContactBookFlow">Trigger Contact Book Flow</mat-checkbox>
                    </div>
                }
                <div class="preview-buttons-container">
                    <a class="need-help-btn" target="_blank"
                       href="https://clickatell.gitbook.io/flow/managing-workflows/using-the-previewer">Need Help?</a>
                    <button class="start-btn" (click)="start()" [disabled]="!isFormValid">Start</button>
                </div>
                <!--      <div class="buttonHolder">-->
                <!--        <button id="dialer" class="toolbar_saveBtn btnPrimary" (click)="start(testDetailsPanel)">-->
                <!--          Preview-->
                <!--        </button>-->
                <!--      </div>-->
            </form>
        </div>
    }
    <mat-expansion-panel
            [expanded]="true"
            [disabled]="true"
            hideToggle="true"
            [ngClass]="showEmulatorDialog ? 'preview-chat-panel' : 'hide-preview-chat-panel'">
        <mat-expansion-panel-header class="preview-chat-panel-header">
            <mat-panel-title class="preview-session-id">
                @if (emulatorChannelConfig | async; as channelConfig) {
                    <div class="selected-channel-container">
                        <div class="selected-channel-img-container">
                            <img class="selected-channel-img"
                                 src="../../../../../assets/img/channel/{{selectedChannel}}.svg" alt="channelImg"/>
                        </div>
                        <div class="selected-channel-name">{{ selectedChannel | channelName }}</div>
                    </div>
                }
                <div class="number-and-restart-container">
                    <span class="selected-mobile-number">{{ sourceId.value }}</span>
                    <div
                        #restartAnchor
                        (click)="toggleRestartPopup()"
                        class="restart-icon-container"
                        matTooltip="Restart preview" matTooltipPosition="below" matTooltipClass="top-left-tooltip1">
                        <div class="restart-icon"></div>
                    </div>
                    <div class="restart-overlay-container"
                         [ngStyle]="{'visibility': (showRestartPopUp) ? 'visible' : 'hidden'}">
                        <div #restartContainer class="restart-confirmation-container">
                            <div class="restart-confirmation-text-container">
                                <img class="restart-alert-img"
                                     src="../../../../../assets/svg/redesign/alert_triangle_clear.svg" alt="">
                                <div class="restart-confirmation-text">Do you want to restart preview?</div>
                            </div>
                            <div class="restart-btn-container">
                                <div class="restart-no" (click)="toggleRestartPopup()">No</div>
                                <div class="restart-yes" (click)="restart()">Yes</div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="preview-chat-window"
             [ngClass]="{
          uploading: inputState === 'uploading',
          recording: (inputState === 'voiceNote' && permission | async),
          'recording-error': inputState === 'voiceNote' && !(permission | async)}"
             #scrollMe
             [scrollTop]="scrollMe.scrollHeight">
            @if (sessionId) {
                <div class="preview-session-id-bubble">
                    <div class="session-id-text-container">Session ID: {{ sessionId }}</div>
                </div>
            }
            @for (emulatorMessage of emulatorDisplayMessages$ | async; track identify($index, emulatorMessage)) {
                <app-chat-bubble [emulatorMessage]="emulatorMessage" (sendMessage)='onInteractiveMessageClick($event)'
                                 (sendLocation)="onSendLocationClick($event)"></app-chat-bubble>
                @if (isEndMessage(emulatorMessage)) {
                    <div class="preview-chat-message-end-container">
                        <div class="preview-chat-message-line"></div>
                        <div class="preview-chat-message-end">End of Chat</div>
                        <div class="preview-chat-message-line"></div>
                    </div>
                }
            }
        </div>
        @if (!showDismiss) {
            <div class="chat-message-container">
                @switch (inputState) {
                    @case ('text') {
                        <form id="chat-form" [formGroup]="emulatorResponseFormGroup">
                            <input id="chat-response"
                                   type="text"
                                   class="preview-chat-response"
                                   [placeholder]="inputPlaceholder"
                                   formControlName="emulatorResponse"
                                   (keydown.enter)="send()"
                                   #responseInput/>
                        </form>
                    }
                    @case ('uploading') {
                        <ng-container *ngTemplateOutlet="uploadInProgress"></ng-container>
                    }
                    @case ('voiceNote') {
                        <app-voice-note
                                [recording]="true"
                                (cancelClick)="cancelRecording()"
                                [wavesurferData]="{ waveColor: '#8cc63f' }"
                                (sendClick)="sendVoiceNote($event)"
                                [(permission)]="permission">
                        </app-voice-note>
                    }
                    @case ('location') {
                        <div class="preview-location-sharing"
                             [@openClose]="inputState === 'location' ? 'open' : 'closed'">
                            @if (contactSendingIsNotDisplayed()) {
                                <app-show-location
                                        class="appShowScroll"
                                        (onClickCancelView)="cancelShowLocationView($event)"
                                        (onShareLocationClick)="onShareLocationClick($event)">
                                </app-show-location>
                            }
                        </div>
                    }
                }
                <ng-template #uploadInProgress>
                    <div class="upload-progress-block">
                        <div class="upload-info-top">
                            <div class="upload-file-info">
                                {{ uploadProgressAction.fileName | truncateFileName }}
                            </div>
                            <div class="upload-progress-status">
                                @if (uploadProgressAction.error) {
                                    <button
                                            class="retry-btn"
                                            (click)="retryUploadHandler()"
                                    >
                                        Retry
                                    </button>
                                }
                                <div class="upload-percent">{{ uploadProgressAction.progress }}%</div>
                                @if (uploadProgressAction.status === 'uploading') {
                                    <button
                                            class="close-btn"
                                            (click)="cancelUploadHandler()"
                                    ></button>
                                }
                                @if (uploadProgressAction.error) {
                                    <div class="upload-error-icon"></div>
                                }
                                @if (uploadProgressAction.status === 'complete') {
                                    <div
                                            class="upload-done-icon"
                                    ></div>
                                }
                            </div>
                        </div>
                        <p class="filesize">
                            {{ uploadProgressAction.size }}
                            <span
                                    class="uploading-status"
                                    [ngClass]="{ 'upload-error': uploadProgressAction.error }"
                            >
                      {{ uploadProgressAction.status }}
                    </span>
                        </p>
                        <mat-progress-bar
                                mode="determinate"
                                [value]="uploadProgressAction.progress"
                        ></mat-progress-bar>
                        <div class="buttons-bar">
                            <button class="btn cancel-btn" (click)="cancelUploadHandler()">Cancel</button>
                            <button
                                    class="btn send-btn"
                                    (click)="sendFileHandler()"
                                    [disabled]="uploadProgressAction.status !== 'complete'"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </ng-template>
                <input
                        type="file"
                        #fileUpload
                        id="fileUpload"
                        name="fileUpload"
                        style="display: none"
                        accept=".pdf, .doc, .ppt, .xls, .docx, .pptx, .xlsx, .jpg, .jpeg, .png, .svg, .aac, .mp4, .amr, .mp3, .opus"
                />
                <div class="hint-asset-container">
                    <div [ngClass]="MEDIA_SUPPORT[selectedChannel] === undefined ? 'add-asset-container-disabled' : 'add-asset-container-enabled'">
                        @if (MEDIA_SUPPORT[selectedChannel] !== undefined) {
                            <div class="asset-btn-container">
                                @if (MEDIA_SUPPORT[selectedChannel].media) {
                                    <button
                                            tooltipPosition="topLeft"
                                            matTooltpClass="mat-tooltip"
                                            matTooltip="Attach file (Max 10 MB)"
                                            class="add-asset-item add-asset"
                                            [ngClass]="{ active: inputState === 'uploading' }"
                                            (click)="uploadFileHandler()"
                                    ></button>
                                }

                                @if (MEDIA_SUPPORT[selectedChannel].location) {
                                    <button
                                            matTooltip="Send location"
                                            matTooltpClass="mat-tooltip"
                                            class="add-asset-item add-location"
                                            [ngClass]="{ active: inputState === 'location' }"
                                            (click)="changeInputState('location')"
                                    ></button>
                                }

                                @if (MEDIA_SUPPORT[selectedChannel].voiceNote) {
                                    <button
                                            matTooltip="Send voice recording"
                                            matTooltpClass="mat-tooltip"
                                            class="add-asset-item add-voice"
                                            [ngClass]="{ active: inputState === 'voiceNote' }"
                                            (click)="changeInputState('voiceNote')"
                                    ></button>
                                }

                                @if (MEDIA_SUPPORT[selectedChannel].contact) {
                                    <button
                                            matTooltip="Send contact card"
                                            matTooltpClass="mat-tooltip"
                                            class="add-asset-item send-contact"
                                            [ngClass]="{ active: inputState === 'sendContact' }"
                                            (click)="openSendContactCard();"
                                    ></button>
                                }
                            </div>
                        }
                    </div>
                    <div class="hint-container">
                        <img class="info-img" src="../../../../../assets/svg/redesign/Info.svg" alt="info.svg">
                        <div class="info-text-container">
                            Enter to send
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="buttonHolder">
                <button class="btnDismiss" (click)="dismiss()">
                    Dismiss
                </button>
            </div>
        }

    </mat-expansion-panel>
    @if (previewModal.isModalOpen) {
        <div class="popup-container">
            <div class="popup-block">
                <div class="popup-header">
                    <div class="close-btn" (click)="closeModal()"></div>
                </div>
                <div class="popup-body">
                    @if (previewModal.previewType === 'video') {
                        <video
                                id="videoPlayer"
                                class="video-player"
                                width="800"
                                height="480"
                                controls
                        >
                            <source [src]="previewModal.src" [type]="previewModal.srcType"/>
                        </video>
                    }
                    @if (previewModal.previewType === 'image') {
                        <img
                                class="preview-image"
                                [src]="previewModal.src"
                        />
                    }
                </div>
            </div>
        </div>
    }

    @if (showSendContactCard) {
        <div class="send-contact-container">
            <send-contact-card (close)="closeSendContact()" (send)="sendContact($event)"></send-contact-card>
        </div>
    }

</div>
